
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';
import { StaffMember } from '@/types/staffTypes';

export const useLocationStaff = (locationId: string) => {
  return useQuery({
    queryKey: ['locationStaff', locationId],
    queryFn: async () => {
      if (!locationId) return [];
      
      const { data, error } = await supabase
        .from('staff_members')
        .select(`
          *,
          staff_locations!inner(location_id)
        `)
        .eq('staff_locations.location_id', locationId);
        
      if (error) {
        console.error('Error fetching staff for location:', error);
        throw error;
      }
      
      return data as StaffMember[];
    },
    enabled: !!locationId
  });
};
